<template>
    <td class="upload-button-td">
        <div v-if="!isLoading">
            <div>
                <input class="btn btn-info" value="Upload" type="button" @click="onClickButtonUpload(investment.investment_id, refName)"/>
                <input
                    type="file"
                    style="display: none"
                    :ref="refName"
                    @change="uploadFile($event, tag, tranchIndex, investment)"
                />
            </div>
            <div v-if="doesDocumentExist(investment, tag)">
                <div v-for="document in investment.documents[tag]">
                    <a :href="getDownloadLink(document)" target="_blank">
                    {{ document.name || '' }}
                    </a>
                    <input class="delete-personal-button" value="X" type="button" @click="onDelete(document.id, investment)" />
                </div>
            </div>
        </div>
        <img v-else src="../../../images/loader.gif" height="40px" width="40px" />
    </td>
</template>

<script>
    export default {
        data() {
            return {
                isLoading: false
            }
        },
        props: ['investment', 'tag', 'getDownloadLink', 'doesDocumentExist', 'activeEmd', 'offering', 'refName', 'onFilePicked', 'deleteFile', 'tranchIndex'],
        methods: {
            onClickButtonUpload() {
                this.$refs[this.refName].click()
            },
            onDelete(id, investment) {
                this.isLoading = true
                this.deleteFile(id, this.tranchIndex, investment)
                    .then((_doneDeleting) => {
                        this.isLoading = false
                    })
            },
            uploadFile(event, tag, tranchIndex, investment) {
                this.isLoading = true
                this.onFilePicked(event, tag, tranchIndex, investment)
                    .then((_doneUploading) => {
                        this.isLoading = false
                    })
            }
        }
    }
</script>
